import { createMentionsConfig } from '@confluence/fabric-media-support/entry-points/MentionsProvider.ts';

export const getMentionProvider = (cloudId: string, environment: string, userId: string | null) => {
	return createMentionsConfig(cloudId, userId)
		.then((config) => config.mentionResource)
		.catch((err) => {
			if (environment !== 'PRODUCTION') {
				// eslint-disable-next-line no-console
				console.error`Failed to initialise mention resource ${err}`;
			}
			return Promise.reject();
		});
};
